import React from "react";
import { NavLink } from "react-router-dom";
import DrawerToggleButton from "./SideDrawer/DrawerToggleButton";
import LinkButton from "./common/linkButton";
import DropDownAction from "./common/dropDownAction";

const NavBar = ({
  drawerClickHandler,
  user,
  newBlankProposal,
  clearProposalState,
  proposalTypes,
  proposals,
  proposalTypesLoading,
  submissionsLoading,
  canAccessSupport = false,
}) => {
  return (
    <nav
      className="navbar fixed-top navbar-expand-xl navbar-light bg-white product-navbar"
    >
      <div className="container">
        <div className="navbar__toggle-button">
          <DrawerToggleButton click={drawerClickHandler} />
        </div>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div
            className="navbar-brand mx-auto"
            style={{
              fontFamily: "Times New Roman, Times, serif",
              fontSize: "1.3rem",
            }}
          ></div>
          <div className="navbar-nav navbar-right">
            {user && (
              <React.Fragment>
                <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                  <li className="nav-item">
                    <LinkButton
                      className="btn btn-success nav-link-item"
                      style={{
                        color: "white",
                        textDecoration: "none",
                        width: "160px",
                      }}
                      to="/proposals/step-guide"
                      onClick={() => newBlankProposal()}
                    >
                      Create Proposal
                    </LinkButton>
                  </li>
                  <li style={{ margin: "auto" }}>
                    <label
                      style={{
                        color: "black",
                        textDecoration: "none",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                      }}
                    ></label>
                  </li>
                  <li className="nav-item">
                    <LinkButton
                      className="btn btn-primary nav-link-item"
                      style={{
                        color: "white",
                        textDecoration: "none",
                        width: "160px",
                      }}
                      to="/plan/step-guide"
                      title="Create Investment Strategy Plan and Fee Disclosure (ISP)"
                      onClick={() => clearProposalState && clearProposalState()}
                    >
                      Create ISP
                    </LinkButton>
                  </li>
                  <li style={{ margin: "auto" }}>
                    <label
                      style={{
                        color: "black",
                        textDecoration: "none",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                      }}
                    ></label>
                  </li>
                  <React.Fragment>
                    <li className="nav-item" style={{ margin: "auto" }}>
                      <NavLink
                        className="nav-link-item"
                        style={{
                          textDecoration: "none",
                        }}
                        to="/submissions"
                      >
                        <button
                          style={{
                            border: "none",
                            backgroundColor: "transparent",
                            outline: "none",
                            color: proposals.length <= 0 ? "gray" : "black",
                          }}
                          disabled={proposals.length <= 0}
                        >
                          {submissionsLoading && (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                              style={{ marginRight: "5px" }}
                            ></span>
                          )}
                          Submissions
                        </button>
                      </NavLink>
                    </li>
                    <li style={{ margin: "auto" }}>
                      <label
                        style={{
                          color: "black",
                          textDecoration: "none",
                          paddingRight: "10px",
                          paddingLeft: "10px",
                        }}
                      ></label>
                    </li>
                  </React.Fragment>
                  <DropDownAction
                    customStyle={{
                      width: "100%",
                      height: "100%",
                      padding: "3px",
                      backgroundColor: "none",
                      color: "black",
                      outline: "none",
                      border: "none",
                    }}
                    style={{
                      padding: "4px 4px",
                      outline: "none",
                      border: "none",
                      borderColor: "white",
                    }}
                    ulStyle={{
                      padding: "0",
                    }}
                    title={
                      <div style={{ paddingBottom: "2px" }}>
                        Options{" "}
                        <span style={{ margin: "auto", fontSize: "10px" }}>
                          &#9660;
                        </span>
                      </div>
                    }
                    drop="dropdown"
                    items={[
                      ...(canAccessSupport
                        ? [
                            <NavLink
                              key="support"
                              className="nav-link-item"
                              style={{
                                color: "black",
                                textDecoration: "none",
                                padding: "4px",
                              }}
                              to="/support"
                            >
                              Support
                            </NavLink>,
                            <hr
                              key="support-divider"
                              style={{ margin: "0px" }}
                            />,
                          ]
                        : []),
                      <NavLink
                        key="settings"
                        className="nav-link-item"
                        style={{
                          color: "black",
                          textDecoration: "none",
                          padding: "4px",
                        }}
                        to="/user"
                      >
                        Settings
                      </NavLink>,
                      <hr key="logout-divider" style={{ margin: "0px" }} />,
                      <NavLink
                        key="logout"
                        className="nav-link-item"
                        style={{
                          color: "black",
                          textDecoration: "none",
                          padding: "4px",
                        }}
                        to="/logout"
                      >
                        Logout
                      </NavLink>,
                    ]}
                  />

                  <li style={{ margin: "auto" }}>
                    <label
                      style={{
                        color: "black",
                        textDecoration: "none",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                      }}
                    ></label>
                  </li>
                  <li className="nav-item" style={{ margin: "auto" }}>
                    <a
                      className="nav-link-item"
                      style={{ color: "black", textDecoration: "none" }}
                      href="https://www.vicuscapital.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      vicuscapital.com
                    </a>
                  </li>
                </ul>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
